(() => {
  const bindSlideInert = (swiper) => {
    if (!swiper || typeof swiper.on !== 'function') return;

    const sync = () => {
      if (!swiper.slides) return;
      Array.from(swiper.slides).forEach((slide) => {
        const visible =
          typeof slide.isVisible === 'boolean'
            ? slide.isVisible
            : slide.classList.contains('swiper-slide-visible');
        if (visible) {
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('inert', '');
        }
      });
    };

    swiper.on('init', sync);
    swiper.on('afterInit', sync);
    swiper.on('slideChange', sync);
    swiper.on('transitionEnd', sync);
    swiper.on('resize', sync);
    swiper.on('breakpoint', sync);
    swiper.on('slidesUpdated', sync);
    sync();
  };

  if (typeof window.customElements.get('collection-list-carousel') !== 'undefined') {
    return;
  }

  window.customElements.define(
    'collection-list-carousel',
    class CollectionListCarousel extends HTMLElement {
      constructor() {
        super();

        this.carousel = this.querySelector('[data-collection-list-carousel-swiper]');
        this.cards = this.querySelectorAll('[data-collection-list-carousel-card]');
        this.boundHandleClickOutside = this.handleClickOutside.bind(this);

        this.initCollectionListCarousel();
      }

      initCollectionListCarousel() {
        try {
          this.setupSwiper();
          this.setupCards();
        } catch (error) {
          console.error('There was a problem with the CollectionListCarousel component:', error);
        }
      }

      setupSwiper() {
        if (!this.carousel) {
          return;
        }

        const prevButton = this.carousel.querySelector('[data-collection-list-carousel-prev]');
        const nextButton = this.carousel.querySelector('[data-collection-list-carousel-next]');
        const collectionSwiper = new Swiper(this.carousel, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          centeredSlides: false,
          loop: false,
          rewind: true,
          watchSlidesProgress: true,
          a11y: { enabled: true },
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
        });

        bindSlideInert(collectionSwiper);

        return collectionSwiper;
      }

      setupCards() {
        if (this.cards.length < 1) {
          return;
        }

        this.cards.forEach((card) => {
          card.addEventListener('click', (e) => {
            const anchor = e.target.closest('a');
            const isAnchor = e.target.tagName === 'A' || anchor !== null;

            if (isAnchor) {
              return;
            }

            e.preventDefault();

            if (card.classList.contains('active')) {
              card.classList.remove('active');
            } else {
              this.cards.forEach((card) => { card.classList.remove('active') });
              card.classList.add('active');
            }
          });
        });

        document.addEventListener('click', this.boundHandleClickOutside);
      }

      handleClickOutside(e) {
        const clickedInsideCard = Array.from(this.cards).some((card) => card.contains(e.target));
        if (!clickedInsideCard) {
          this.cards.forEach((card) => card.classList.remove('active'));
        }
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.boundHandleClickOutside);
      }
    }
  );
})();
